// 中文语言包zh.js
export default {
  route: {
    receiveAward: '立即领取',
    congratulation: '恭喜获得',
    name: '姓名',
    phone: '手机号',
    email: '邮箱'
  }
}
